import { Product, ProductIdentifiers } from '@inter-ikea-storageone/range';

export const removeMirroredProducts = (products: Product[]) => {
  return products.filter(
    product => !product.coreProductId.includes(ProductIdentifiers.MIRRORED_PRODUCT)
  );
};
